import type { UserProfile } from '../stores/userStore'

export type ProfileGapField = 'birthday' | 'location' | 'time'

export type ProfileGaps = {
  missingBirthday: boolean
  missingLocation: boolean
  missingTime: boolean
  anyMissing: boolean
  primaryGap: ProfileGapField | null
}

const EMPTY: ProfileGaps = {
  missingBirthday: false,
  missingLocation: false,
  missingTime: false,
  anyMissing: false,
  primaryGap: null,
}

export function getProfileGaps(profile: Pick<
  UserProfile,
  'birthday' | 'birthTime' | 'birthTimeSkipped' | 'birthLocation' | 'birthLatitude' | 'birthLongitude'
> | null | undefined): ProfileGaps {
  if (!profile) return EMPTY

  const missingBirthday = !profile.birthday
  const missingLocation =
    !profile.birthLocation || !profile.birthLatitude || !profile.birthLongitude
  const missingTime = !profile.birthTime && !profile.birthTimeSkipped

  const anyMissing = missingBirthday || missingLocation || missingTime

  let primaryGap: ProfileGapField | null = null
  if (missingBirthday) primaryGap = 'birthday'
  else if (missingLocation) primaryGap = 'location'
  else if (missingTime) primaryGap = 'time'

  return { missingBirthday, missingLocation, missingTime, anyMissing, primaryGap }
}
